import React from "react";
import "../css/ProgressBar.css"

export const ProgressBar: React.FC<any> = () => {
    return (
        <div className="progress-bar-container">
            <div className="progress-bar"></div>
        </div>
    );
};